<template>
  <div>
  <create-culture-card/>
  <culture-list-table/>
  </div>
</template>

<script>

import CultureListTable from "../../components/culture-table/CultureListTable";
import CreateCultureCard from "../../components/culture-table/CreateCultureCard";

export default {
  name: "CultureTableView",
  components: {
    'culture-list-table': CultureListTable,
    'create-culture-card': CreateCultureCard
  }
}


</script>

<style scoped>

</style>